<template>
  <div>
    <table-row-view :data-list='tableData' :setting='setting'></table-row-view>
  </div>
</template>

<script>
import TableRowView from '@/pages/plc/compoents/TableRowView'

export default {
  name: 'PlcExcelTable',
  components: { TableRowView },
  props: {
    setting: {
      type: Object,
      default() {
        return {}
      }
    },
    tableData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
